module.exports = require("@angular/material/snack-bar");